import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import LeadForm from '../LeadForm';
import Button from '../../shared/library/Button/Button';
import styles from './css/PlanningGuideLeadForm.styl';
import {
  buildSalesforcePayload,
  sendToWebcollect,
} from '../../../appModules/utilities/salesforceApi';
import classNames from 'classnames';

const cx = classNames.bind(styles);

export const GUIDE_LINK =
  'https://image.alerts.legacy.com/lib/fe3d157075640578751778/m/1/e4547d61-9371-4041-b78d-697954775c8f.pdf';
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

class PlanningGuideLeadForm extends Component {
  static propTypes = {
    visibleFields: PropTypes.arrayOf(PropTypes.string),
    theme: PropTypes.oneOf(['light', 'dark']),
  };

  static defaultProps = {
    visibleFields: ['firstName', 'lastName', 'email'],
    theme: 'light',
  };

  initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    zipCode: this.props.planning.funeralHomeZipcode,
  };

  fields = [
    {
      name: 'firstName',
      title: 'First Name',
      required: true,
    },
    {
      name: 'lastName',
      title: 'Last Name',
      required: true,
    },
    {
      name: 'email',
      type: 'email',
      title: 'Email',
      required: true,
    },
    {
      name: 'zipCode',
      type: 'tel',
      title: 'Zip Code',
      required: true,
    },
    {
      name: 'phoneNumber',
      type: 'tel',
      title: 'Phone',
    },
  ];

  getFields = () => {
    const {visibleFields} = this.props;

    return this.fields.filter(field => {
      return visibleFields.includes(field.name);
    });
  };

  handleFormSubmit = (formValues, formik) => {
    let funeralHome = this.props.funeralHome;

    const {
      affiliate,
      webcollectKey = 'WebCollectFHD_standard',
      planning,
    } = this.props;

    if (!funeralHome && planning.funeralHomeZipcode) {
      funeralHome = {location: {postalCode: planning.funeralHomeZipcode}};
    }

    formik.setStatus({
      loading: true,
      error: false,
    });

    const body = buildSalesforcePayload({
      form: 'planningGuide',
      formValues,
      funeralHome,
      affiliate,
    });

    sendToWebcollect({body, externalKey: webcollectKey})
      .then(json => {
        const {success, error = undefined} = json; // eslint-disable-line no-undefined

        formik.setSubmitting(false);
        formik.setStatus({
          loading: false,
          success,
          error,
        });
      })
      .catch(() => {
        formik.setSubmitting(false);
        formik.setStatus({
          loading: false,
          error: true,
          success: false,
        });
      });
  };

  render() {
    const {theme} = this.props;

    const classes = {
      PlanningGuideLeadForm: true,
      Light: theme === 'light',
      Dark: theme === 'dark',
    };

    return (
      <div className={cx(classes)}>
        <LeadForm
          initialValues={this.initialValues}
          onSubmit={this.handleFormSubmit}
          submitText="Download the Guide"
          fields={this.getFields()}
          theme="dark"
          renderSuccess={() => {
            return (
              <div>
                <p className={styles.SuccessMessage}>Success! Thank you.</p>
                <Button
                  href={GUIDE_LINK}
                  type="large-button"
                  className={styles.SuccessButton}
                  target="_blank"
                  download="Your Guide to Planning Ahead"
                >
                  Download Your Guide
                </Button>
              </div>
            );
          }}
        />
        <p>
          By submitting this form you agree to our{' '}
          <a target="_blank" href="https://www.legacy.com/about/terms-of-use">
            Terms of Use.
          </a>
        </p>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  planning: state.planningStore,
});

export default connect(mapStateToProps)(PlanningGuideLeadForm);



// WEBPACK FOOTER //
// ./src/reactModules/shared/PlanningGuideLeadForm/index.js